<template>
	<Row :gutter="[16, 8]">
		<Col :span="18" :offset="0">
			<VerticalLayout>
				<StatsChartTitleWithDescription
					titleKey="stats.spoofing.gssHeatmap.chartTitle"
					descriptionKey="stats.spoofing.gssHeatmap.chartTitleTooltipMedian"
					titleClass="pd-lg-x pd-md-top"
				/>
				<HeatMapChart
					v-if="mountpointsSelected.length > 0 && datesRangeStr != null"
					:isLoading="isLoading"
					:series="heatmapSeries"
					:categories="heatmapCategories"
					colorSettingsMode="exact"
					:colorSettings="colorSettings"
					:noDataLabel="$t('stats.spoofing.gssHeatmap.legend.noData')"
					showLabelNamesInTooltip
					:xAxisLabel="$t('stats.spoofing.gssHeatmap.xAxisLabel')"
					:tooltipFooter="$t('stats.spoofing.gssHeatmap.tooltipDualFrequencyNote')"
				/>
				<EmptyChartFiltersMessage v-else messageKey="stats.spoofing.gssHeatmap.mountpointsPlaceholder" />
			</VerticalLayout>
		</Col>
		<Col :span="6" :offset="0">
			<VerticalLayout>
				<Card :bordered="false">
					<VerticalLayout>
						<BaseStationSelect
							v-model="mountpointsSelected"
							:onUpdate="fetchStatsItems"
							:placeholderKey="'stats.spoofing.gssHeatmap.mountpointsPlaceholder'"
						/>
						<div class="pd-vertical">
							<span>{{ $t('stats.spoofing.gssHeatmap.visibilityThresholdLabel') }}</span>
							<Select
								class="width-100"
								v-model:value="visibilityThreshold"
								:options="visibilityThresholdOptions"
							/>
						</div>
						<DateRangeChooserMaxSpan
							v-if="gssDateRangeLimit.enabled"
							v-model="datesRange"
							:maxSpanDays="gssDateRangeLimit.maxDays"
							@change="fetchStatsItems"
						/>
						<DateRangeChooser
							v-else
							v-model="datesRange"
							quickPeriod="day1"
							@change="fetchStatsItems"
						/>
					</VerticalLayout>
				</Card>
			</VerticalLayout>
		</Col>
	</Row>
</template>

<script lang="ts">
import { Row, Col, Card, Select } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import DateRangeChooser from '@/components/common/DateRangeChooser.vue';
import DateRangeChooserMaxSpan from '@/components/common/DateRangeChooserMaxSpan.vue';
import BaseStationSelect from '@/components/common/controls/BaseStationSelect.vue';
import StatsChartTitleWithDescription from '@/components/stats/StatsChartTitleWithDescription.vue';
import EmptyChartFiltersMessage from '@/components/charts/EmptyChartFiltersMessage.vue';
import HeatMapChart from '@/components/charts/HeatMapChart.vue';
import { useSpoofingGssHeatmap } from '@/components/stats/useSpoofingGssHeatmap';


export default {
	components: {
		Row, Col, Card, Select,
		VerticalLayout, DateRangeChooser, DateRangeChooserMaxSpan, BaseStationSelect,
		StatsChartTitleWithDescription, EmptyChartFiltersMessage, HeatMapChart,
	},
	setup() {
		return useSpoofingGssHeatmap('median');
	},
};
</script>
